import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useFeature, useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { FlexGap, tokens } from '@treams/treams-ui';

import { StyrBadge } from '../../../../connectors/products/StyrBadge';
import SettingsCollection, {
	ArchiveRestoreMutationTuple,
} from '../../../generic/SettingsCollection';
import { GrowthPathScaleSettings } from './GrowthPathScaleSettings';

export default function CareersSettings() {
	const { t } = useTranslation();
	const history = useHistory();
	const { localize } = useLocalize();
	const showGrowthPathScale = useFeature(graphql.FeatureName.GrowthPathScale);

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.page}>
			<SettingsCollection
				query={graphql.useCareersQuery}
				lazyQuery={graphql.useCareersLazyQuery}
				field="careers"
				translationKey="settings.growthPath.careers"
				title={(career) => {
					const title = localize(career.title).text;
					const expertise = localize(career.expertise?.title ?? []).text;

					return expertise ? `${title} - ${expertise}` : title;
				}}
				titleBadge={(career) =>
					career.styrData ? <StyrBadge tooltip={t('common.settings.careers.styr.badge')} /> : null
				}
				link={(career) => `/settings/jobs/growth-path/${career.id}`}
				variables={{}}
				archive={graphql.useArchiveCareerMutation() as unknown as ArchiveRestoreMutationTuple}
				restore={graphql.useRestoreCareerMutation() as unknown as ArchiveRestoreMutationTuple}
				onAdd={() => history.push('/settings/jobs/growth-path/new')}
			/>
			{showGrowthPathScale && <GrowthPathScaleSettings />}
		</FlexGap>
	);
}
